import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap} from 'rxjs';
import {Injectable} from '@angular/core';
import {PaymentProviderService} from "@modules/payment/services/payment-provider.service";

@Injectable({
  providedIn: 'root'
})
export class PaymentProviderInitializerEffects {
  initPaymentProviders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.paymentProviderService.ensureLoaded$()),
      catchError(e => {
        console.error(e);

        this.paymentProviderService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    protected readonly actions$: Actions,
    protected readonly paymentProviderService: PaymentProviderService,
  ) {
  }
}
